import React, { useEffect, useState } from 'react';
import { useSelectedFavourites } from '../../zustand/SelectedFavourites';
import CustomButton from '../shared/button/CustomButton';
import { useGames } from '../shared/hooks/useGames';
import Overview from './overview/Overview';
import {
  StyledBox,
  StyledPaper,
  StyledTypo,
} from './styled/OverviewAndFilter.styled';
import { useNavigate } from 'react-router-dom';
import { useSelectedGamesForBCResult } from '../../zustand/GamesFromSelectedTeams';
import useGamesFromSelectedTeams from '../shared/hooks/useGamesFromSelectedTeams';
import usePreferredFilter from '../../zustand/Filter';
import Filter from './filter/Filter';

const OverviewAndFilter: React.FC = () => {
  const { selectedCompetitions, selectedTeams } = useSelectedFavourites();
  const { games: allGames } = useGames();
  const { isOnlyUpcoming } = usePreferredFilter();
  const navigate = useNavigate();
  const { setGamesFromSelectedTeams } = useSelectedGamesForBCResult();

  const gamesFromSelectedTeams = useGamesFromSelectedTeams({
    selectedTeams,
    allGames,
    selectedCompetitions,
    isOnlyUpcoming,
  });

  useEffect(() => {
    if (gamesFromSelectedTeams.length > 0) {
      setGamesFromSelectedTeams(gamesFromSelectedTeams);
    }
  }, [isOnlyUpcoming]);

  const handleSearch = () => {
    navigate('/bestcombination');
  };

  const shouldButtonDisabled =
    selectedCompetitions.length === 0 && selectedTeams.length === 0;
  return (
    <>
      <StyledTypo
        variant="h4"
        align="left"
        fontWeight="bold"
        fontStyle="italic"
        marginLeft={4}
      >
        Overview and filter
      </StyledTypo>
      <StyledPaper elevation={3}>
        <Overview />
      </StyledPaper>

      <StyledPaper elevation={3}>
        <Filter />
      </StyledPaper>

      <StyledBox>
        <CustomButton
          onClick={handleSearch}
          label="Show result"
          size="large"
          disabled={shouldButtonDisabled}
        />
      </StyledBox>
    </>
  );
};

export default OverviewAndFilter;
